import {Button} from '@wandb/weave/components/Button';
import React from 'react';

import {useIsInLoadedReportContext} from '../../pages/ReportPage/LoadedReportContext';
import {useGetIsMediaPanelSettingsDrawerSupportedForPanel} from '../PanelMediaBrowser/useGetIsMediaPanelSettingsDrawerSupportedForPanel';
import {
  useWorkspaceDrawerContextMaybe,
  WorkspaceDrawerContextType,
} from '../WorkspaceDrawer/WorkspaceDrawerContextProvider';
import {useDetectPanelVariant} from './hooks';
import {StyledButtonWrapper} from './PanelActions.style';
import {usePanelContext} from './PanelContextProvider';
import {useOpenPanelEditor} from './PanelHeader/useOpenPanelEditor';
import {PanelPopupMode} from './types';

export const PanelSettingsButton = () => {
  const {isFullScreenPanelPage} = useDetectPanelVariant();
  const isReport = useIsInLoadedReportContext();

  const {
    panelBankSectionConfigRef,
    panelRef,
    panel,
    setPanelPopupMode,
    trackPanelControls,
  } = usePanelContext();

  const openPanelEditor = useOpenPanelEditor();

  const getIsMediaPanelSettingsDrawerSupportedForPanel =
    useGetIsMediaPanelSettingsDrawerSupportedForPanel(panel);

  const workspaceDrawerContext = useWorkspaceDrawerContextMaybe();
  let openWorkspaceDrawer:
    | undefined
    | WorkspaceDrawerContextType['openWorkspaceDrawer'] = undefined;

  if (workspaceDrawerContext) {
    openWorkspaceDrawer = workspaceDrawerContext.openWorkspaceDrawer;
  }

  return (
    <StyledButtonWrapper
      className="panel-action hide-in-hidden-panels"
      data-test="edit-panel-button">
      <Button
        icon="settings"
        variant="ghost"
        aria-label="Edit panel"
        size={isFullScreenPanelPage ? 'medium' : 'small'}
        tooltip={'Edit panel'}
        tooltipProps={{className: 'py-8 px-12'}}
        onClick={() => {
          if (
            !isReport &&
            getIsMediaPanelSettingsDrawerSupportedForPanel() // Lazily call this since we only need to know once the Edit panel is clicked
          ) {
            // open it in full screen mode if it's enabled so that the panel is larger when making edits
            if (!isFullScreenPanelPage) {
              openPanelEditor();
            }
            openWorkspaceDrawer?.(
              'media-settings',
              panelBankSectionConfigRef,
              panelRef
            );
          } else {
            setPanelPopupMode(PanelPopupMode.EDIT);
          }
          trackPanelControls({action: 'Edit panel clicked'});
        }}
      />
    </StyledButtonWrapper>
  );
};
